import { gql } from '@apollo/client'

import { LOCATION_TYPE_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_MUTATION = gql`
  mutation setIsCurationEnabledLocationTypeOrLocationTypeCategory(
    $id: ID!
    $isCurationEnabled: Boolean!
    $type: String!
  ) {
    setIsCurationEnabledLocationTypeOrLocationTypeCategory(
      id: $id
      isCurationEnabled: $isCurationEnabled
      type: $type
    ) {
      ...LocationTypeNodeFragment
    }
  }
  ${LOCATION_TYPE_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_MUTATION
